import { InputHTMLAttributes } from 'react';

import { cn } from './cn';

export interface SliderProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'value' | 'onChange'> {
  value: number;
  onValueChange?: (value: number) => void;
  onValueCommit?: (value: number) => void;
  marks?: { value: number; label: string }[];
  showValue?: boolean;
  formatValue?: (value: number) => string;
}

export const Slider = ({
  className,
  formatValue = value => String(value),
  marks,
  max = 100,
  min = 0,
  onValueChange,
  onValueCommit,
  showValue,
  value,
  ...props
}: SliderProps) => {
  const commit = (event: { currentTarget: HTMLInputElement }) => onValueCommit?.(Number(event.currentTarget.value));
  return (
    <div className={cn('flex w-full flex-col gap-1', className)}>
      <div className="flex items-center gap-3">
        <input
          type="range"
          min={min}
          max={max}
          value={value}
          className="h-1.5 w-full cursor-pointer accent-brand disabled:cursor-not-allowed disabled:opacity-50"
          onChange={event => onValueChange?.(Number(event.currentTarget.value))}
          onPointerUp={commit}
          onKeyUp={commit}
          {...props}
        />
        {showValue && (
          <output className="min-w-10 text-right text-xs font-medium tabular-nums text-ink-muted">
            {formatValue(value)}
          </output>
        )}
      </div>
      {marks && marks.length > 0 && (
        <div className="flex justify-between text-caption text-ink-muted">
          {marks.map(mark => (
            <span key={mark.value}>{mark.label}</span>
          ))}
        </div>
      )}
    </div>
  );
};
